// extracted by mini-css-extract-plugin
export default {"Icons":"Icons_Icons__xETLS","notepadIcon":"Icons_notepadIcon__-zQWk","imageIcon":"Icons_imageIcon__PyfB6","projectsBinIcon":"Icons_projectsBinIcon__+EAuP"};